import { api } from "../apiCore";
import { SignInfo } from "../../types/signInfo.type";
import { DocumentWithMetaData } from "../../../types/documents.type";

type DocumentsForSigningDto = {
  application_bank_id: number;
  application_id: number;
  bankTitle: string;
  documents: DocumentWithMetaData[];
};

export type GetSignInfoQueryParams = {
  applicationBankId: number;
  fileId: number;
  signId: number;
};

export const signingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // получить документы на подписание (запрашивает по номеру заявки документы на подписание)
    getDocumentsForSigning: builder.query<DocumentsForSigningDto, number>({
      query: (applicationBankId) => ({
        url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/sign`,
        method: "POST",
      }),
      providesTags: (result, error, applicationBankId) => [
        {
          type: "ApplicationBank",
          applicationBankId,
        },
      ],
      transformResponse: (response: { data: DocumentsForSigningDto }) =>
        response.data,
    }),

    // получить информацию о подписи
    getSignInfo: builder.query<SignInfo, GetSignInfoQueryParams>({
      query: ({ applicationBankId, fileId, signId }) => ({
        url: `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/${fileId}/sign/${signId}/checked`,
        method: "GET",
      }),
      transformResponse: (response: { data: SignInfo }) => response.data,
    }),
  }),
});

export const { useGetDocumentsForSigningQuery, useGetSignInfoQuery } =
  signingApi;
